<template>
    <div class="customer-document-list">
        <show-qr-code @close="onCloseSignature" ref="signdocument" id="customer-document-sign" title="Firmar Documento"
            :url="signature_url"></show-qr-code>

        <div class="row">
            <div class="col-4 mb-2">
                <h5 class="customer-document-list__title">
                    DOCUMENTOS ADJUNTOS
                </h5>
            </div>
            <div class="col">
                <button class="btn-wabident-round small mx-2" @click="onAdd()"> <i class="fas fa-plus"></i> </button>
            </div>
        </div>
        <div v-for="document, index in documents" :key="index"
            class="form-group row customer-document-list__item px-1 py-1 mb-2 mx-1">
            <div class="customer-document-list__date col-2 d-flex align-items-center">
                {{ documentDate(document) }}
            </div>
            <div class="customer-document-list__type col-2 d-flex align-items-center">
                {{ documentType(document) }}
            </div>
            <div class="customer-document-list__type col d-flex align-items-center">
                <strong>{{ document.title }}</strong>
            </div>
            <div class="customer-document-list__buttons col-3 d-flex align-items-center justify-content-end">
                <template v-if="document.type == 'consent'">
                    <button v-if="document.is_signed" class="btn-wabident-round small" @click="trySign(document)"
                        style="background-color: var(--theme-color-attended);"><i class="fa fa-pencil"
                            aria-hidden="true"></i> </button>
                    <button v-else class="btn-wabident-round small" @click="trySign(document)"><i class="fa fa-pencil"
                            aria-hidden="true"></i> </button>
                </template>
                <button class="btn-wabident-round small mx-2" @click="onView(document)"><i class="fas fa-search"></i>
                </button>
                <button class="btn-wabident-round small" @click="onEdit(document)"><i class="fas fa-edit"></i> </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        customer: {
        },
        documents: {
            default() {
                return [];
            }
        }
    },
    data() {
        return {
            signature_url: "",
            doc_types: {
                document: 'Archivo',
                consent: 'Cons.',
                report: 'Inf.',
                proof: 'Justif.',
                prescription: 'Receta',
                lab_work: 'T. Laboratorio',
            }
        }
    },
    computed: {
        ...mapGetters(["msgwindow", "errorwindow", "clinic"])
    },
    methods: {
        resignDocument(document) {
            this.errorwindow.show(
                "Confirmación",
                "¿Deseas volver a firmar el Documento?. Esto invalidará firma anterior",
                "Firmar",
                "Cancelar",
                () => {
                    this.signDocument(document, true);
                }
            );
        },
        trySign(document) {
            if (document.is_signed) {
                this.resignDocument(document);
            } else {
                this.signDocument(document);
            }
        },
        signDocument(document, resign = false) {
            if (!this.is_loading) {
                this.is_loading = true;

                let params = {};
                if (resign) {
                    params.resign = true;
                }

                axios
                    .get(
                        `/customer/${this.customer.id}/document/${document.id}/signature`,
                        { params }
                    )
                    .then((response) => {
                        let url = response.data.url;
                        if (url) {
                            this.signature_url = url;
                            this.$refs.signdocument.show();

                        } else {
                            this.msgwindow.error(
                                "Error firmando documento: " + (response.data.error || "")
                            );
                        }

                    })
                    .catch((error) => {
                        console.log("[ERR] signDocument", error);
                        this.msgwindow.error("Error firmando documento !");
                    })
                    .then(() => {
                        this.is_loading = false;
                    });
            }
        },
        onCloseSignature() {
            this.signature_url = "";
        },
        documentType(document) {
            return this.doc_types[document.type] || 'N/D';
        },
        documentDate(document) {
            return moment(document.created_at).format('DD/MM/YY');
        },
        onAdd() {
            this.$emit('add');
        },
        onEdit(document) {
            this.$emit('edit', document);
        },
        onView(document) {
            window.open(`/customer/${this.customer.id}/document/${document.id}/view`);
        }
    }
}

</script>

<style lang="scss">
.customer-document-list {
    &__title {
        font-size: 14px;
        margin: 5px 0 10px 5px;
        font-weight: 600;
    }

    &__item {
        background-color: var(--theme-grey-bg);
        border-bottom: 1px #a0a4b0 solid;
    }

    &__type {
        font-size: 12px;
    }

    margin-bottom: 15px;
}
</style>